// src/pages/onboarding/ProfileStep.jsx
import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  MenuItem,
  Grid,
} from "@mui/material";

const businessTypes = [
  "Individual Agent",
  "Team Lead",
  "Brokerage Owner",
  "Transaction Coordinator",
  "Other",
];

const experienceLevels = [
  "New (0-2 years)",
  "Growing (2-5 years)",
  "Experienced (5-10 years)",
  "Veteran (10+ years)",
];

export default function ProfileStep({ onNext, onBack }) {
  const [form, setForm] = useState({
    phone: "",
    businessType: "",
    experience: "",
  });

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = () => {
    // Merge profile data into stored user
    const existingUser = localStorage.getItem("agentBlayna_user");
    const userData = existingUser ? JSON.parse(existingUser) : {};
    const updatedUser = { ...userData, ...form };
    localStorage.setItem("agentBlayna_user", JSON.stringify(updatedUser));

    onNext();
  };

  return (
    <Box>
      <Typography variant="h4" fontWeight={800} gutterBottom textAlign="center">
        A bit more about you
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4, textAlign: "center" }}
      >
        This helps us personalize your AgentBlayna experience.
      </Typography>

      <Grid container spacing={2} sx={{ maxWidth: 500, mx: "auto" }}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Phone Number"
            value={form.phone}
            onChange={handleChange("phone")}
            placeholder="(555) 123-4567"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            select
            label="I am a..."
            value={form.businessType}
            onChange={handleChange("businessType")}
          >
            {businessTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            select
            label="Experience Level"
            value={form.experience}
            onChange={handleChange("experience")}
          >
            {experienceLevels.map((level) => (
              <MenuItem key={level} value={level}>
                {level}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>

      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        sx={{ mt: 4 }}
      >
        <Button variant="outlined" onClick={onBack} sx={{ px: 4 }}>
          Back
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{ px: 4, fontWeight: 700 }}
        >
          Continue
        </Button>
      </Stack>
    </Box>
  );
}
